import { useState } from "react"
import { makeStyles } from "tss-react/mui"
import YouTube, { YouTubeProps } from "react-youtube"
import { ConferenceMerchantQuery, ConferenceViewResponse, fetchConferenceView } from "../conferenceApi"
import { useApiQuery } from "../../../../../core/api/useApiQuery"
import { useMerchant } from "../../../../merchants/merchantHooks"

const useStyles = makeStyles()(() => ({
    iframeWrapper: {
        width: "100%",
        height: "100vh",
        position: "relative",
        zIndex: 0,
        overflow: "hidden",
        opacity: 0,
        transition: "opacity 0.5s ease-in-out",
    },
    iframeVisible: {
        opacity: 1,
    },
    iframe: {
        width: "100%",
        height: `calc(100vh + 3.75rem)`,
        marginTop: "-3.75rem",
    },
}))

function transformData({ conferenceDetails }: ConferenceViewResponse) {
    return conferenceDetails.video
}

export function VideoSection() {
    const { classes } = useStyles()
    const { merchantId } = useMerchant()
    const [isVideoReady, setIsVideoReady] = useState(false)

    const { data: conferenceViewResult } = useApiQuery(fetchConferenceView, {
        queryName: ConferenceMerchantQuery.CONFERENCE_VIEW,
        dependencies: {
            merchantId,
        },
        select: transformData,
        suspense: true,
        useErrorBoundary: true,
    })

    const onPlayerReady: YouTubeProps["onReady"] = (event) => {
        setIsVideoReady(true)
        const availableQualityLevels = event.target.getAvailableQualityLevels()
        if (availableQualityLevels.length > 0) {
            const bestQuality = availableQualityLevels[0]
            console.log("bestQuality", availableQualityLevels)
            event.target.setPlaybackQuality(bestQuality)
        }
    }

    const onPlaybackQualityChange: YouTubeProps["onPlaybackQualityChange"] = (event) => {
        console.log("Playback quality changed to:", event.target.getPlaybackQuality())
    }

    return (
        <YouTube
            videoId={conferenceViewResult?.youtubeVideoId}
            opts={{
                playerVars: {
                    autoplay: 1,
                    loop: 1,
                    mute: 1,
                    playlist: conferenceViewResult?.youtubeVideoId || [],
                    controls: 0,
                    modestbranding: 1,
                    rel: 0,
                    fs: 0,
                    disablekb: 1,
                    iv_load_policy: 3,
                    cc_load_policy: 0,
                },
            }}
            onReady={onPlayerReady}
            onPlaybackQualityChange={onPlaybackQualityChange}
            className={`${classes.iframeWrapper} ${isVideoReady ? classes.iframeVisible : ""}`}
            iframeClassName={classes.iframe}
        />
    )
}
